import { Component, OnInit } from '@angular/core';
import { PwaService } from './core/services/pwa.service';
import { SettingsService } from './core/services/settings.service';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'Bilali Islamic Shopping';

  constructor(
    private pwaService: PwaService,
    private settingsService: SettingsService
  ) {}

  ngOnInit(): void {
    // Update document title with company name
    this.settingsService.settings$.subscribe(settings => {
      if (settings && settings.company_name) {
        const companyName = settings.company_name.trim() || 'Bilali Islamic Shopping';
        this.title = companyName;
        document.title = `${companyName}`;
      } else {
        this.title = 'Bilali Islamic Shopping';
        document.title = 'Bilali Islamic Shopping';
      }
    });

    // Only register service worker in production to avoid cache issues during development
    if (environment.production) {
      this.pwaService.registerServiceWorker().then(() => {
        console.log('[App] PWA initialized successfully');
      }).catch(error => {
        console.error('[App] PWA initialization failed:', error);
      });

      // Request persistent storage for offline functionality
      this.pwaService.requestPersistentStorage();
    } else {
      console.log('[App] Service Worker disabled in development mode');
      // Unregister service worker if it was previously registered (to clear cache)
      this.pwaService.unregisterServiceWorker().then(() => {
        console.log('[App] Service Worker unregistered for development');
      });
      // Clear all caches in development to prevent stale data
      this.pwaService.clearCache().then(() => {
        console.log('[App] Caches cleared for development');
      });
    }

    // Listen for online/offline status
    this.pwaService.isOnline$.subscribe(isOnline => {
      if (!isOnline) {
        console.log('[App] You are currently offline. Some features may be limited.');
      } else {
        console.log('[App] You are back online!');
      }
    });

    // Listen for app updates
    this.pwaService.updateAvailable$.subscribe(updateAvailable => {
      if (updateAvailable) {
        console.log('[App] A new version is available!');
        // You can show a notification to the user here
      }
    });
  }
}
